/*
 * vpseSystem.ts
 */
import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import type { AxiosResponse } from 'axios';
import { eLCeSystemAPI } from 'src/boot/axios';
import { mcUtils } from 'src/utils/utils';
import type { mtAxiosReturn } from 'src/config/config.type.axios';
// import { moAxiosReturn } from 'src/config/config.type.axios';
import { vpsUser } from 'src/user/vpsUser';
import type { mteSystemCatModOps } from 'src/config/config.type.eSystemCatModOps';
//
export const vpseSystem = defineStore('vpseSystem', () => {
  const mpsUser = vpsUser();
  // Column Break Point Size, for responsive sizing quasar (html) element
  const msColBPSize = 'col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2';
  //
  // NOTE 20250429: Remove! Use process.env.NODE_ENV!!! =?= prod | stage | dev
  // NOTE: process.env.NODE_ENV is set at ENVIRONMENT level!!!
  // NOTE: quasar runtime overwrite process.env.NODE_ENV to 'development' | 'production'!!!
  // NOTE: added 2 more boolean variables for ENVIRONMENT checking!!!
  // const mbEnvModeDEV = process.env.ENV_MODE === 'DEV' ? true : false;
  // const vrbEnvModeDEVDEV = ref(process.env.ENV_MODE === 'DEV' ? true : false);
  //
  // ASSUME DEVelopment environment
  // WARN: 20250704: vrbEnvModeDEV alway set to false && vrbEnvModePRD is set to true!!!
  // WARN:           CANNOT FIND OUT WHY!!! So appended the 3 characters on all 3 variables!!!
  // WARN:           AND IS WORK!!!
  const vrbEnvModeDEVDEV = ref(true);
  const vrbEnvModeSTGSTG = ref(false);
  const vrbEnvModePRDPRD = ref(false);
  //
  if (true === Boolean(process.env.PROD) && true === Boolean(process.env.DEBUGGING)) {
    // stage environment (PRODuction with debug)
    vrbEnvModeDEVDEV.value = false;
    vrbEnvModeSTGSTG.value = true;
    vrbEnvModePRDPRD.value = false;
  } else if (true === Boolean(process.env.PROD)) {
    // PRODuction environment
    vrbEnvModeDEVDEV.value = false;
    vrbEnvModeSTGSTG.value = false;
    vrbEnvModePRDPRD.value = true;
  }
  //
  const vrbVersion = ref(false);
  const vrsVersion = ref('0.0.0');
  const vrbeSystemCatModOps = ref(false);
  const vraeSystemCatModOps = ref<mteSystemCatModOps[]>([]);
  const vrbIsLogin = ref(false);
  const vrsCategorySelected = ref<string>('eLCPteLtd');
  const vrsOperationCallParam = ref<string>('0');
  //
  async function mfGeteSystemVersion(): Promise<mtAxiosReturn> {
    let loAxiosReturn: mtAxiosReturn;
    //
    // Continue to check whether Backup API server is alive!!!
    // This is triggered each time the vcpTheHeader.vue is mounted.
    //
    const loAxiosConfig = {
      url: '/',
      method: 'get',
      data: {},
    };
    try {
      const loAxiosResponse: AxiosResponse = await eLCeSystemAPI.request(loAxiosConfig);
      // Get OK
      vrbVersion.value = true;
      vrsVersion.value = loAxiosResponse.data.ksAppVersion;
      //
      loAxiosReturn = mcUtils.cpsoAxios.cpifGetReturnOK(loAxiosResponse);
      //
    } catch (poError: unknown) {
      vrbVersion.value = false;
      vrsVersion.value = 'E.R.R';
      loAxiosReturn = mcUtils.cpsoAxios.cpifGetReturnError(poError);
    }
    //
    return loAxiosReturn;
  }
  async function mfGeteSystemCatModOps(): Promise<mtAxiosReturn> {
    //
    // console.log('vpseSystem.ts-mfGeteSystemCatModOps()!');
    //
    let loAxiosReturn: mtAxiosReturn;
    if (true === vrbeSystemCatModOps.value) {
      loAxiosReturn = mcUtils.cpsoAxios.cpifGetAlreadyInit();
      return loAxiosReturn;
    }
    //
    const loAxiosConfig = {
      url: '/esystem/setting/catmodops',
      method: 'get',
      data: {},
    };
    try {
      const loAxiosResponse = await eLCeSystemAPI.request(loAxiosConfig);
      // Get OK
      vrbeSystemCatModOps.value = true;
      // vraeSystemCatModOps.value = loAxiosResponse.data.kaeSystemCatModOps;
      vraeSystemCatModOps.value = loAxiosResponse.data.cpiaeSystemCatModOps;
      //
      // console.log('vraeSystemCatModOps.value', JSON.stringify(vraeSystemCatModOps.value));
      //
      loAxiosReturn = mcUtils.cpsoAxios.cpifGetReturnOK(loAxiosResponse);
      //
    } catch (poError: unknown) {
      vrbeSystemCatModOps.value = false;
      vraeSystemCatModOps.value = [];
      loAxiosReturn = mcUtils.cpsoAxios.cpifGetReturnError(poError);
    }
    //
    return loAxiosReturn;
  }
  //
  async function mfRefresheSystemCatModOps(): Promise<mtAxiosReturn> {
    vrbeSystemCatModOps.value = false;
    const loAxiosReturn: mtAxiosReturn = await mfGeteSystemCatModOps();
    //
    return loAxiosReturn;
  }
  //
  function mfSetLogin(pbIsLogin: boolean): void {
    vrbIsLogin.value = pbIsLogin;
    if (false === pbIsLogin) {
      //
      // enable refreshing of eSystem-Cat-Mod-Ops list upon logout
      //
      vrbeSystemCatModOps.value = false;
    } else {
      vrbeSystemCatModOps.value = false;
      void mfGeteSystemCatModOps();
    }
  }
  //
  function mfSetCategorySelected(psCategory: string): void {
    vrsCategorySelected.value = psCategory;
  }
  //
  function mfSetOperationCallParam(psOperationCallParam: string): void {
    vrsOperationCallParam.value = psOperationCallParam;
  }
  //
  const vcrGetEnvModeDEV = computed(() => {
    return vrbEnvModeDEVDEV.value;
  });
  const vcrGetEnvModeSTG = computed(() => {
    return vrbEnvModeSTGSTG.value;
  });
  const vcrGetEnvModePRD = computed(() => {
    return vrbEnvModePRDPRD.value;
  });
  //
  const vcrGeteSystemVersion = computed(() => {
    return vrsVersion.value;
  });
  const vcrGeteSystemCatModOps = computed(() => {
    return vraeSystemCatModOps.value;
  });
  const vcrGetIsLogin = computed(() => {
    return vrbIsLogin.value;
  });
  const vcrGetCategoryByUserRole = computed(() => {
    return vraeSystemCatModOps.value.filter((poElement) => {
      return mpsUser.vcrGetMyUserRole.some((peUserRole) => {
        return poElement.cpiaUserRole.includes(peUserRole);
      });
    });
  });
  const vcrGetCategorySelected = computed(() => {
    return vrsCategorySelected.value;
  });
  const vcrGetCategoryCaption = computed(() => {
    const loCategory = vraeSystemCatModOps.value.find((poElement) => {
      return poElement.cpisCategory === vrsCategorySelected.value;
    });
    if (loCategory) {
      return loCategory.cpisUX;
    }
    return 'CAPTION NOT FOUND';
  });
  const vcrGetCategoryModule = computed(() => {
    //
    // Deep copy array (without object reference)
    //
    const laeSystemCatModOps = <mteSystemCatModOps[]>JSON.parse(JSON.stringify(vraeSystemCatModOps.value));
    //
    const loCategory = laeSystemCatModOps.find((poElement) => {
      return poElement.cpisCategory === vrsCategorySelected.value;
    });
    if (loCategory) {
      //return loCategory.cpiaeSystemModule;
      //
      // 1. Filter module that user has no access
      const laModule = loCategory.cpiaeSystemModule.filter((poModule) => {
        return mpsUser.vcrGetMyUserRole.some((peUserRole) => {
          return poModule.cpiaUserRole.includes(peUserRole);
        });
      });
      const laModuleTarget = [...laModule];
      // 2. For each module, filter opeartion that user has no access
      laModuleTarget.forEach((poModule) => {
        const laOperation = poModule.cpiaeSystemOperation.filter((poOperation) => {
          return mpsUser.vcrGetMyUserRole.some((peUserRole) => {
            return poOperation.cpiaUserRole.includes(peUserRole);
          });
        });
        poModule.cpiaeSystemOperation = [...laOperation];
      });

      return laModuleTarget;
    }
    return [];
  });
  const vcrGetOperationCallParam = computed(() => {
    return vrsOperationCallParam.value;
  });
  //
  return {
    msColBPSize,
    vrbEnvModeDEVDEV,
    vrbEnvModeSTGSTG,
    vrbEnvModePRDPRD,
    vrbVersion,
    vrsVersion,
    vrbeSystemCatModOps,
    vraeSystemCatModOps,
    vrbIsLogin,
    vrsCategorySelected,
    vrsOperationCallParam,
    mfGeteSystemVersion,
    mfGeteSystemCatModOps,
    mfRefresheSystemCatModOps,
    mfSetLogin,
    mfSetCategorySelected,
    mfSetOperationCallParam,
    vcrGetEnvModeDEV,
    vcrGetEnvModeSTG,
    vcrGetEnvModePRD,
    vcrGeteSystemVersion,
    vcrGeteSystemCatModOps,
    vcrGetIsLogin,
    vcrGetCategoryByUserRole,
    vcrGetCategorySelected,
    vcrGetCategoryCaption,
    vcrGetCategoryModule,
    vcrGetOperationCallParam,
  };
});
//#end#
